import { useStats } from '../../../lib/ctx/stats'
import { getStreakDate, getStreakDay, monthsNames } from '../../../lib/utils'
import { StreakStat } from '../../../types'
import { StreakCalendarGridItem } from './types'

export const useStreakCell = () => {
  const [month, stats] = useStats((s) => [s.streakMonth, s.stats])
  const results = stats?.streaks?.results || []
  const bestStreak = stats?.streaks?.best_streak
  const streaks =
    results.find((s) => s.month === monthsNames[month - 1])?.streaks || []

  const isBestStreak = (streak: StreakStat) => {
    const streakDate = streak ? getStreakDate(streak.date) : null
    const bestStart = getStreakDate(bestStreak?.start_date || '')
    const bestEnd = getStreakDate(bestStreak?.end_date || '')

    return !!streakDate && streakDate >= bestStart && streakDate <= bestEnd
  }

  const getStreakCell = (cell: StreakCalendarGridItem) => {
    if (!cell.isCurrentMonth) return

    const streak = streaks.find(
      (s) => getStreakDay(s.date) === cell.day
    ) as StreakStat

    const isBest = isBestStreak(streak)

    return { streak, isBest }
  }

  return { getStreakCell }
}
